document.addEventListener('DOMContentLoaded', function() {
  const announcementBar = document.querySelector('[data-announcement-timer]');
  if (!announcementBar) return;

  const endTimeStr = announcementBar.getAttribute('data-end-time');
  const closeButton = announcementBar.querySelector('.anvibha-announcement-close');
  
  const daysEl = announcementBar.querySelector('[data-days]');
  const hoursEl = announcementBar.querySelector('[data-hours]');
  const minutesEl = announcementBar.querySelector('[data-minutes]');
  const secondsEl = announcementBar.querySelector('[data-seconds]');


  // Parse end time
  function parseEndTime(timeStr) {
    // Expected format: YYYY-MM-DD HH:MM
    const parts = timeStr.split(' ');
    if (parts.length !== 2) return null;
    
    const dateParts = parts[0].split('-');
    const timeParts = parts[1].split(':');
    
    if (dateParts.length !== 3 || timeParts.length !== 2) return null;
    
    return new Date(
      parseInt(dateParts[0]), // year
      parseInt(dateParts[1]) - 1, // month (0-indexed)
      parseInt(dateParts[2]), // day
      parseInt(timeParts[0]), // hours
      parseInt(timeParts[1]), // minutes
      0 // seconds
    );
  }

  const endTime = parseEndTime(endTimeStr);
  
  if (!endTime || isNaN(endTime.getTime())) {
    console.error('Invalid end time format');
    return;
  }

  function updateTimer() {
    const now = new Date().getTime();
    const distance = endTime.getTime() - now;

    if (distance < 0) {
      // Timer expired
      announcementBar.style.display = 'none';
      clearInterval(timerInterval);
      return;
    }

    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

    daysEl.textContent = String(days).padStart(2, '0');
    hoursEl.textContent = String(hours).padStart(2, '0');
    minutesEl.textContent = String(minutes).padStart(2, '0');
    secondsEl.textContent = String(seconds).padStart(2, '0');
  }

  // Close button functionality
  closeButton.addEventListener('click', function() {
    announcementBar.style.display = 'none';
  });

  // Update timer immediately and then every second
  updateTimer();
  const timerInterval = setInterval(updateTimer, 1000);
});
